import Cookie from "universal-cookie";

const cookie = new Cookie();
export default cookie;
export const removeSession = () => {
  cookie.remove("auth");
  cookie.remove("permission");
  cookie.remove("name");
  window.location.reload();
};
